// extracted by mini-css-extract-plugin
export const card = "styles-module--card--12Rk_";
export const content = "styles-module--content--MdZd9";